<template>
  <form @submit.prevent="handleSubmit">
    <modal-card :title="form.id ? 'Edit coupon' : 'Generate New Coupons'" style="margin: 0 auto;" contains-dropdown>
      <div class="columns" v-if="form.id == null">
        <div class="column is-6">
          <b-field label="Plan type">
            <b-select v-model="form.model_type" expanded>
              <option value="magazine-plan">Plan</option>
              <option value="magazine-issue">Issue</option>
              <option value="magazine-campaign">Campaign</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Code">
            <b-input type="text" min="1" max="255" v-model="form.code" placeholder="Generate auto if it's empty"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns" v-if="form.id != null">
        <div class="column is-12">
          <b-field label="Code">
            <b-input type="text" min="1" max="255" v-model="form.code" placeholder="Generate auto if it's empty"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns" v-else>
        <div class="column is-6">
          <b-field :label="nameGenerate(form.model_type)">
            <plan-selector v-if="form.model_type == 'magazine-plan'" v-model="form.model_id">
            </plan-selector>
            <issue-selector v-if="form.model_type == 'magazine-issue'" v-model="form.model_id">
            </issue-selector>
            <campaign-selector v-if="form.model_type == 'magazine-campaign'" v-model="form.model_id">
            </campaign-selector>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Count">
            <b-input type="number" min="1" max="10000" v-model="form.count"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <b-field label="Expire Date">
            <datetimepicker v-model="form.expired_at"></datetimepicker>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Max Redeem Count">
            <b-input type="number" min="1" max="10000" v-model="form.max_redeem_count"></b-input>
          </b-field>
        </div>
      </div>

      <b-field label="Note">
        <b-input type="text" v-model="form.note"></b-input>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
          v-if="form.id == null"
        >
          Generate
        </button>
        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
          v-else
        >
          Save change
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import PlanSelector from "../../../../../modules/admin/pages/magazine/coupons/components/selectors/PlanSelector";
import IssueSelector from "@/modules/admin/pages/magazine/coupons/components/selectors/IssueSelector";
import CampaignSelector from "@/modules/admin/pages/magazine/coupons/components/selectors/CampaignSelector";
export default {
  components: {
    PlanSelector,
    IssueSelector,
    CampaignSelector
  },
  props: {
    added: {
      type: Function,
      required: true
    },
    group_id: {
      type: String,
      required: true
    },
    coupon: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      form: new window.Form({
        expired_at: this.coupon ? this.coupon.expired_at : null,
        model_id: this.coupon ? this.coupon.model_id : null,
        model_type: this.coupon ? this.coupon.model_type : 'magazine-plan',
        max_redeem_count: this.coupon ? this.coupon.max_redeem_count : 1,
        count: this.coupon ? 0 : 1,
        note: this.coupon ? this.coupon.note : null,
        group_id: this.coupon ? this.coupon.group_id : this.group_id,
        code: this.coupon ? this.coupon.code : null,
        id: this.coupon ? this.coupon.id : null
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form.post("/admin/api/promo/coupon/generate").then(this.whenAdded);
    },

    whenAdded(response) {
      this.added();
      this.$buefy.toast.open(response.message);
      this.$parent.close();
    },

    nameGenerate(type){
      var str = type.split("-")[1];
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
};
</script>
